














































































import { cloneDeep } from 'lodash'
import isMobile from 'piramis-js-utils/lib/isMobile'
import { Component, Mixins, Prop, VModel, Watch } from 'vue-property-decorator'

import MultiCurrencyInput from '../../CurrensyInput/MultiCurrencyInput.vue'
import CurrencyInput from '../../CurrensyInput/components/input.vue'
import { UseFields } from '../../Pi'
import { FieldData } from '../../Pi/types'
import CurrenciesHelperMixin from "../CurrenciesHelperMixin";
import ProductsCore from './index'
import { CreateProductModel, EditProductModel, ProductType } from './types'

@Component({
  data() {
    return {
      isMobile,
    }
  },
  components: {
    CurrencyInput,
    MultiCurrencyInput,
  }
})
export default class ProductsEditor extends Mixins(UseFields, CurrenciesHelperMixin) {
  @VModel() current!: number | null

  @Prop() core!: ProductsCore

  imgTemplate = 0

  @Watch('current')
  productWatcher(id: number | null): void {
    if (id) {
      if (id === -1) {
        this.productCopy = {
          cost: 0,
          currency: this.$i18n.locale === 'ru' ? 'RUB' : 'USD',
          name: '',
          type: ProductType.Service,
          description: '',
          image: '',
        }
        this.imgTemplate += 1
        this.isOpen = true
      } else {
        const product = this.core.getProduct(id)

        if (product) {
          const { state, ...otherFields } = product

          this.productCopy = cloneDeep(otherFields)
          this.imgTemplate += 1
          this.isOpen = true
        }
      }
    } else {
      this.isOpen = false
      this.productCopy = null
    }
  }

  productCopy: CreateProductModel | EditProductModel | null = null

  isOpen = false

  modelSetter(arg: FieldData): FieldData {
    arg.setter = (val) => {
      arg.model[arg.key] = val
    }
    return arg
  }

  setPrice(arg: FieldData): FieldData {
    arg.setter = ({ cost, currency }) => {
      if (this.productCopy) {
        this.productCopy.cost = cost
        this.productCopy.currency = currency
      }
    }
    return arg
  }

  okHandler(): void {
    if (this.current && this.productCopy) {
      if (this.current === -1) {
        this.core.createProductHandler(this.productCopy).finally(() => this.current = null)
      } else {
        if ('id' in this.productCopy) {
          this.core.editProductHandler(this.productCopy).finally(() => this.current = null)
        }
      }
    }
  }

}
